__turbopack_context__.v({
  "container": "styles-module__G5Q67G__container",
  "ctaWrapper": "styles-module__G5Q67G__ctaWrapper",
  "heroImage": "styles-module__G5Q67G__heroImage",
  "imageContainer": "styles-module__G5Q67G__imageContainer",
  "section": "styles-module__G5Q67G__section",
  "textWrapper": "styles-module__G5Q67G__textWrapper",
});
